export function itemRemove(array, predicate) {
    if (!array)
        return undefined;
    const index = array.findIndex(predicate);
    if (index === -1)
        return array;
    return array.toSpliced(index, 1);
}
// TODO: Add support for `Set`
export function withItemRemove(predicate) {
    return (array) => itemRemove(array, predicate);
}
export function itemUpdate(array, predicate, update) {
    if (!array)
        return undefined;
    const index = array.findIndex(predicate);
    if (index === -1)
        return array;
    const currentValue = array[index];
    const newValue = update(currentValue);
    if (currentValue === newValue)
        return array;
    return array.toSpliced(index, 1, newValue);
}
/**
 * Clones an array and appends items to it.
 *
 * @public
 */
// TODO: Add support for `Set`
export function itemAppend(array, ...items) {
    return (array ?? []).concat(items);
}
/**
 * Clones an array and prepends items to it.
 *
 * @public
 */
// TODO: Add support for `Set`
export function itemPrepend(array, ...items) {
    return (array ?? []).toSpliced(0, 0, ...items);
}
/**
 * Searches for an entity in an array using a provided ID selector,
 * and if found, removes it from the array, otherwise returns the
 * original array.
 *
 * @public
 */
// TODO: Add support for `Set` and `Map`
export function withEntityRemove() {
    return (collection, idToRemove) => {
        return itemRemove(collection, (entity) => entity.id === idToRemove);
    };
}
/**
 * Swaps two elements in an array and returns a new array.
 * If the indices are the same or out of bounds, the original array is returned.
 *
 * @public
 */
// TODO: Add support for `Set`
export function itemSwap(array, indexA, indexB) {
    if (indexA === indexB || !(indexA in array) || !(indexB in array)) {
        return array;
    }
    // Clone the array; `slice` is (by far) the fastest way to do this
    const result = array.slice();
    const valueA = result[indexA];
    result[indexA] = result[indexB];
    result[indexB] = valueA;
    return result;
}
/**
 * If the property's value is the same as the new value, return the state.
 * Otherwise, return a new state with the updated property.
 *
 * @public
 */
export function propUpdate(state, propertyName, nextValue) {
    const currentValue = state[propertyName];
    if (currentValue === nextValue) {
        return state;
    }
    return {
        ...state,
        [propertyName]: nextValue,
    };
}
/**
 * Reduces an action into a boolean indicating if the action has an error.
 *
 * @public
 */
export function actionHasError(_state, action) {
    return !!action.error;
}
export function withBranch(predicate, trueReducer, falseReducer) {
    return (state, action) => {
        if (predicate(state, action)) {
            return trueReducer(state, action);
        }
        return falseReducer(state, action);
    };
}
/**
 * A reducer that applies a reducer for an action containing an error,
 * and another reducer for a successful action.
 *
 * @public
 */
export function withErrorBranch(errorReducer, reducer) {
    return withBranch(actionHasError, errorReducer, reducer);
}
export function withPropSet(propertyName, _getValue) {
    return (state, action) => {
        const getValue = _getValue ?? ((c, p) => p);
        return propUpdate(state, propertyName, getValue(state[propertyName], action.payload));
    };
}
// An alias for withPropSet that may be more intuitive in some contexts
export const toProp = withPropSet;
/**
 * A no-op utility that helps to define the type of a reducer.
 */
export function define(reducer) {
    return reducer;
}
